export default "__VITE_ASSET__DlWXvmN9__$_?component__"